import { type SvgProps, SvgWrapper } from '../utils';

export function ArrowLeftIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967C12.8232 4.76256 12.8232 5.23732 12.5303 5.53022L6.81055 11.2499H19C19.4142 11.2499 19.75 11.5857 19.75 11.9999C19.75 12.4142 19.4142 12.7499 19 12.7499H6.81055L12.5303 18.4697C12.8232 18.7626 12.8232 19.2373 12.5303 19.5302C12.2374 19.8231 11.7626 19.8231 11.4697 19.5302L4.46973 12.5302C4.17684 12.2373 4.17684 11.7626 4.46973 11.4697L11.4697 4.46967Z" />
    </SvgWrapper>
  );
}
